import { useMemo } from "react";
import { Efficiency, WorkDisplayPeriod } from "../../../../../../types/service/dashboard/IWorksDashboardService";

export const useEfficiencyElements = (period: WorkDisplayPeriod, data: Efficiency) => {
    return useMemo(() => {
        return [
            {
                name: 'Время работы',
                color: '#18D87C',
                id: 'Время работы',
                duration: period === 'full' ? data.totalWorkDuration : data.efficiencyForToday.totalWorkDuration
            },
            {
                name: 'Время простоев',
                color: '#5B9DFF',
                id: 'Время простоев',
                duration: period === 'full' ? data.totalIdleDuration : data.efficiencyForToday.totalIdleDuration
            },
            {
                name: 'Время перегонов',
                color: '#FA8E2E',
                id: 'Время перегонов',
                duration: period === 'full' ? data.totalTransportationDuration : data.efficiencyForToday.totalTransportationDuration
            }
        ]
    }, [data, period])
}